export const QUERY_KEY = {
  useWorkstations: ['print_preferences', 'workstations'] as const,
} as const;
